import React from 'react';
import { userTypes } from '../constants/constants';
import { getUserData } from '../services/API';
//Images
import studentPlayIcon from '../images/speech-icons/studentPlay.svg';
import studentPauseIcon from '../images/speech-icons/studentPause.svg';
import studentDisabledIcon from '../images/speech-icons/studentDisabled.svg';
import teacherPlayIcon from '../images/speech-icons/teacherPlay.svg';
import teacherPauseIcon from '../images/speech-icons/teacherPause.svg';
import teacherDisabledIcon from '../images/speech-icons/teacherDisabled.svg';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import { GetBrandedTutorName } from '../services/BrandingService';

function StudentButton({ onClick, icon, text, extraClass }) {
  if(process.env.ENABLE_PAUSE_BUTTON !== "TRUE"){
    return(null);
  } else{
    return (
      <div className="speechButtonWrapper" {...doNotUseAccessibleStaticElementInteractions({onClick: onClick})}>
        <div className={`studentButton ${extraClass} labelFontOverride`}>
          <img src={icon} className="speechIcon" alt="" />
          <span className="speechButtonTitle">{text}</span>
        </div>
      </div>
    );
  }
}

function TeacherButton({ onClick, icon, text, extraClass }) {
  return (
    <div className={"speechButtonWrapper"} {...doNotUseAccessibleStaticElementInteractions({onClick: onClick})}>
      <div className={`teacherButton ${extraClass} labelFontOverride`}>
        <img src={icon} className="speechIcon" alt="" />
        <span className="speechButtonTitle">{text}</span>
      </div>
    </div>
  );
}

export default class SpeechButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleStartButton = this.handleStartButton.bind(this);
    this.pauseChat = this.pauseChat.bind(this);
  }

  handleStartButton(){
    this.props.speech.abortSpeech();
    this.props.speech.resetTranscript();
    this.props.speech.startListening();
  }

  pauseChat() {
    this.props.speech.stopListening();
    this.props.speech.abortSpeech();
  }

  render() {
    const { userType } = getUserData();

    let btnConfig = {};
    if(this.props.speech.isSpeaking){
      btnConfig = {
        icon: userType == userTypes.STUDENT ? studentDisabledIcon : teacherPauseIcon,
        text: userType == userTypes.STUDENT ? "pause" : `Turn ${GetBrandedTutorName()} Off`,
        onClick: userType == userTypes.STUDENT ? null : this.pauseChat,
        extraClass: userType == userTypes.STUDENT ? "inactive" : "pauseBtn",
      };
    }else if(this.props.speech.isListening){
      btnConfig = {
        icon: userType == userTypes.STUDENT ? studentPauseIcon : teacherPauseIcon,
        text: userType == userTypes.STUDENT ? "pause" : `Turn ${GetBrandedTutorName()} Off`,
        onClick: this.pauseChat,
        extraClass: "pauseBtn",
      };
    }else {
      btnConfig = {
        icon: userType == userTypes.STUDENT ? studentPlayIcon : teacherPlayIcon,
        text: userType == userTypes.STUDENT ? "start" : `Work with ${GetBrandedTutorName()}`,
        onClick: this.handleStartButton,
        extraClass: "startBtn",
      }
    }

    return userType == userTypes.STUDENT ? <StudentButton {...btnConfig} /> : <TeacherButton {...btnConfig} />;
  }
}